import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const restaurantBooking = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getSlots (restaurantId, siteId, dates) {
    const config = utils.generateQueryString({dates}, false)
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/${siteId}/restaurants/${restaurantId}/slots`, config)
  },
  getMealSlots (restaurantId, date) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/restaurants/${restaurantId}/meal-slots?date=${date}`)
  },
  createBookingOfAnUser (restaurantId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/restaurants/${restaurantId}/bookings`, body)
  },
  createBookingWithMealOfAnUser (restaurantId, body) {
    return Axios.post(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/restaurants/${restaurantId}/meals/bookings`, body)
  },
  createBooking (restaurantId, body) {
    return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/bookings`, body)
  },
  deleteBooking (restaurantId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.public}/clients/${this.getClientId()}/restaurants/${restaurantId}/bookings/${bookingId}`)
  },
  getRestaurantsWithBookingsWithFilter (term, restaurantId, date) {
    const config = utils.generateQueryString({term, restaurantId, date}, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/active`, config)
  },
  manageDeleteBooking (restaurantId, bookingId) {
    return Axios.delete(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/restaurants/${restaurantId}/bookings/${bookingId}`)
  },
  getUserBookedDates(start, finish) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/restaurants-bookings?start=${start}&finish=${finish}`)
  }
}

export default restaurantBooking
